import { moduleSettings } from "../stores/module-settings.store";
import { Theme } from "./Theme";

let currentTheme: Theme;
export class ThemeManager {
  public static getTheme(): Theme {
    let theme = moduleSettings.getCustomTheme;
    if (theme) {
      currentTheme = new Theme(theme);
      if (moduleSettings.backgroundImageUrl || (moduleSettings.bodyBackgroundColor && moduleSettings.bodyBackgroundColor !== "#ffffff"))
        currentTheme.isBackground = true;
    }

    return currentTheme;
  }
}
